/**
 * Configuration for the observability harness.
 *
 * IMPORTANT: this module must not be consulted to decide *whether* the harness
 * runs. That check lives inline in index.js as a bare `import.meta.env` test so
 * the bundler can statically prove it false and drop the Sentry import
 * entirely. Reading the flag through here would defeat that. See README.md.
 */

/** Release identity, stamped by the Docker build (see Dockerfile). */
export const RELEASE = `graphit-frontend@${import.meta.env.VITE_GIT_SHA || 'dev'}`

/** Deployment environment, for filtering in the Sentry UI. */
export const ENVIRONMENT =
  import.meta.env.VITE_SENTRY_ENV || import.meta.env.MODE || 'development'

/** Session replay is opt-in; see README.md for the cost implications. */
export const REPLAY_ENABLED = import.meta.env.VITE_SENTRY_REPLAY === '1'

/**
 * Fraction of *all* sessions recorded, not just errored ones. Costs one replay
 * from the monthly quota per session, so it is deliberately a dial rather than a
 * boolean. `0` keeps replay error-only.
 *
 * Anything unparseable or out of range falls back to 0: a typo here would
 * otherwise silently spend the whole allowance.
 */
export const REPLAY_SESSION_SAMPLE_RATE = (() => {
  const raw = import.meta.env.VITE_SENTRY_REPLAY_SESSION_RATE
  if (!raw) return 0
  const rate = Number.parseFloat(raw)
  if (!Number.isFinite(rate) || rate < 0 || rate > 1) {
    console.warn(
      `[observability] ignoring VITE_SENTRY_REPLAY_SESSION_RATE="${raw}": expected a number between 0 and 1`,
    )
    return 0
  }
  return rate
})()

/** How many recent API failures to carry on a report. */
export const API_FAILURE_BUFFER_SIZE = 10
